import { Component, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { AuthService } from 'app/modules/auth/auth.service';

export interface AccessBlockDialogData {
  disableComment: string;
  countDown: number;
}

@Component({
  selector: 'app-access-block',
  standalone: true,
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './access-block.component.html',
})
export class AccessBlockComponent implements OnInit {
  readonly dialogRef = inject(MatDialogRef<AccessBlockComponent>);
  readonly data = inject<AccessBlockDialogData>(MAT_DIALOG_DATA);

  countDown: number;
  loading: number = 0;

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.countDown = this.data.countDown;

    if (this.countDown && this.countDown > 0) {
      this.accessBlockCountDown();
      setTimeout(() => {
        this.dialogRef.close();
      }, this.countDown * 1000);
    }
  }

  public accessBlockCountDown() {
    const interval = setInterval(() => {
      if (this.countDown > 0) {
        this.countDown = this.countDown - 1;
      } else {
        clearInterval(interval);
      }
    }, 1000);
  }

  logout(): void {
    this.loading++;
    this.authService.logout().subscribe({
      next: () => {
        this.authService.profile.set(null);
        this.dialogRef.close();
        this.router.navigate(['/login']);
        this.loading--;
      },
      error: () => {
        this.loading--;
      },
    });
  }
}
